/* unplugin-vue-components disabled */import script from "./breadcrumb.vue?vue&type=script&lang=ts&setup=true"
export * from "./breadcrumb.vue?vue&type=script&lang=ts&setup=true"

import "./breadcrumb.vue?vue&type=style&index=0&id=ce76065a&lang=scss&scoped=true"

import exportComponent from "E:\\aodong\\work\\plus\\aodong-system-web-plus\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce76065a"]])

export default __exports__